import { render } from "./EditTaskDialog.vue?vue&type=template&id=254b7b55"
import script from "./EditTaskDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__